import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-arrow-down-01-Stroke',
  standalone: true,
  templateUrl: '../../assets/arrow-down-01/Stroke.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamArrowDown01StrokeIcon {}
